import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';

import { theme } from '../../../common/ui/theme';
import { Tooltip } from '../../Tooltip/Tooltip';
import { MARKER_TARGET_WIDTH } from '../util/MarkerTargetWidth';

const TooltipTarget = styled.div`
    position: absolute;
    background-color: transparent;
    top: -4px;
    width: ${MARKER_TARGET_WIDTH}px;
    height: 12px;
`;

interface MarkerProps {
    variant: InternalProgressBarMarkerProps['variant'];
    dimmed?: boolean;
}

const regularVariant = variant({
    prop: 'variant',
    variants: {
        neutral: {
            backgroundColor: theme.colors.foreground.default,
        },
        accent: {
            backgroundColor: theme.colors.accent.emphasis,
        },
        attention: {
            backgroundColor: theme.colors.attention.emphasis,
        },
        negative: {
            backgroundColor: theme.colors.negative.emphasis,
        },
    },
});

const dimmedVariant = variant({
    prop: 'variant',
    variants: {
        neutral: {
            backgroundColor: theme.colors.border.default,
        },
        accent: {
            backgroundColor: theme.colors.accent.border,
        },
        attention: {
            backgroundColor: theme.colors.attention.border,
        },
        negative: {
            backgroundColor: theme.colors.negative.border,
        },
    },
});

const Marker = styled.div<MarkerProps>`
    height: 12px;
    width: 2px;
    border-radius: 2px;
    margin-left: 4px;
    outline: 2px solid ${theme.colors.background.default};

    ${(props) => (props.dimmed ? dimmedVariant(props) : regularVariant(props))}
`;

export interface InternalProgressBarMarkerProps {
    value: number;
    variant?: 'neutral' | 'accent' | 'attention' | 'negative';
    dimmed?: boolean;
    children?: ReactNode;
    /**
     * not working, used internally in the ProgressBar component
     */
    style?: CSSProperties;
}

export const InternalProgressBarMarker = ({
    // the variable `value` is used in the ProgressBar component to calculate the position of the marker
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    value,
    variant = 'neutral',
    dimmed,
    children,
    style,
}: InternalProgressBarMarkerProps) => {
    return (
        <Tooltip label={children} showArrow side="bottom">
            <TooltipTarget style={style}>
                <Marker variant={variant} dimmed={dimmed} />
            </TooltipTarget>
        </Tooltip>
    );
};
